import { TokenResponse } from '../types';

export class Token {
  public constructor(public readonly payload: TokenResponse) {}
}
